import { render } from "./HeroConsult.vue?vue&type=template&id=65fe80de"
import script from "./HeroConsult.vue?vue&type=script&lang=js"
export * from "./HeroConsult.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__